import * as i0 from '@angular/core';
import { Component, Input, ElementRef, ContentChild, Pipe, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

//istanbul ignore next
class FieldSetWrapperComponent {
    constructor() {
        this.label = '';
        this.fieldsetClass = '';
        this.legendSrOnly = false;
        this.alignVertical = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FieldSetWrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FieldSetWrapperComponent, selector: "[data-uxd-form-group-cmp]", inputs: { label: "label", fieldsetClass: "fieldsetClass", legendSrOnly: "legendSrOnly", alignVertical: "alignVertical" }, ngImport: i0, template: `
              <fieldset [ngClass]="fieldsetClass">
                <legend [class.sr-only]="legendSrOnly" [innerHTML]="label"></legend>
                <span [class.align-vertical]="alignVertical">
                  <ng-content></ng-content>
                </span>
              </fieldset>
             `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FieldSetWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-form-group-cmp]',
                    template: `
              <fieldset [ngClass]="fieldsetClass">
                <legend [class.sr-only]="legendSrOnly" [innerHTML]="label"></legend>
                <span [class.align-vertical]="alignVertical">
                  <ng-content></ng-content>
                </span>
              </fieldset>
             `
                }]
        }], propDecorators: { label: [{
                type: Input
            }], fieldsetClass: [{
                type: Input
            }], legendSrOnly: [{
                type: Input
            }], alignVertical: [{
                type: Input
            }] } });

//istanbul ignore next
/**
 *  Usage:
 *  <div data-tcp-form-item [definition]="{errorDefs: {required: 'required toggle button'}, showErrors: btnToggleSw.errors, inputErrors: btnToggleSw.errors}">
 *     <div #input #btnToggleSw="ngModel" required ngDefaultControl data-tcp-toggle-switch-cmp [id]="'btnToggleSw'" [name]="'btnToggleSw'"
 *    [(ngModel)]="toggleTest" [labelText]="'toggle switch'" [options]="[{label:'On',value: 'on'},{label:'Off',value:'off'}]"></div>
 *  </div>
 *  <div data-tcp-form-item [definition]="{errorDefs:{required: content.errors.reqErrText}, showErrors:btnToggleSw.errors, inputErrors:btnToggleSw.errors}">
 *     <input #input #txtTest="ngModel" type="text" required [id]="'txtTest'" [name]="'txtTest'"/>
 *  </div>
 */
class FormItemComponent {
    constructor(_renderer) {
        this._renderer = _renderer;
        this.definition = {
            id: "",
            showErrors: false
        };
        this.errorMessage = "";
        this.elementType = "";
        this.elementId = "";
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.elementType =
                this.inputElement &&
                    this.inputElement.nativeElement &&
                    this.inputElement.nativeElement.type
                    ? this.inputElement.nativeElement.type.toLowerCase()
                    : "";
            if (/^(text|tel|password|number|email)$/.test(this.elementType)) {
                this._renderer.addClass(this.inputElement.nativeElement, "ant-text-input");
                if (this.definition.waterMark) {
                    this._renderer.addClass(this.inputElement.nativeElement, "pfText");
                }
            }
            if (this.inputElement &&
                this.inputElement.nativeElement &&
                this.inputElement.nativeElement.id) {
                this.elementId = this.inputElement.nativeElement.id;
                if (this.definition.errorDefs) {
                    let ariaDes = (this.inputElement.nativeElement).getAttribute("aria-describedby");
                    ariaDes = (ariaDes ? `${ariaDes} ` : "") + `errors_${this.elementId}`;
                    this._renderer.setAttribute(this.inputElement.nativeElement, "aria-describedby", ariaDes);
                }
            }
        }, 0);
    }
    ngOnChanges(changes) {
        let errors = changes.inputErrors
            ? changes.inputErrors.currentValue
            : this.definition.inputErrors;
        let showErr = changes.showErrors
            ? changes.showErrors.currentValue
            : this.definition.showErrors;
        this.errorMessage = "";
        if (errors && showErr && this.definition.errorDefs) {
            Object.keys(this.definition.errorDefs).some((key) => {
                if (errors[key]) {
                    this.errorMessage = this.definition.errorDefs[key];
                    return true;
                }
                return false;
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormItemComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FormItemComponent, selector: "[data-uxd-form-item-cmp]", inputs: { definition: "definition" }, queries: [{ propertyName: "inputElement", first: true, predicate: ["input"], descendants: true, read: ElementRef }], usesOnChanges: true, ngImport: i0, template: `<div class="form-item" [class.has-error]="definition.showErrors">
              <label *ngIf="definition.label" [id]="'lbl_'+elementId" class="" [for]="elementId" [innerHTML]="definition.label"></label>
              <span [id]="'tTip_'+elementId" class="pfText" [innerHTML]="definition.waterMark" *ngIf="definition.waterMark"></span>
              <ng-content></ng-content>
              <div [id]="'errors-container_'+elementId" [attr.role]="definition.isStatus ? 'status' : null" [attr.aria-live]="definition.isStatus ? 'polite' : null">
                <div [id]="'errors_'+elementId" *ngIf="errorMessage && !definition.alwaysShowErrors" class="text-negative ant-float-left ant-full-width error-msgs clearfix">
                  <span [id]="elementId+'Err'" class="ant-form-item-error ant-float-left" [innerHTML]="errorMessage"></span>
                </div>
                <div class="clearfix" [id]="'errors_'+elementId" *ngIf="definition.alwaysShowErrors && definition.showErrors">
                  <ng-container *ngFor="let errDef of (definition.errorDefs | objKeys); let i = index;">
                    <span [id]="'err_'+elementId+i" class="ant-float-left ant-full-width" [class.ant-form-item-error]="definition.inputErrors && definition.inputErrors[errDef]" [class.ant-form-item-valid]="!definition.inputErrors || !definition.inputErrors[errDef]"
                    [innerHTML]="definition.errorDefs[errDef]"></span>
                  </ng-container>
                </div>
              </div>
             </div>`, isInline: true, dependencies: [{ kind: "directive", type: i0.forwardRef(function () { return i1.NgForOf; }), selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i0.forwardRef(function () { return i1.NgIf; }), selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i0.forwardRef(function () { return ObjectKeysPipe; }), name: "objKeys" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "[data-uxd-form-item-cmp]",
                    template: `<div class="form-item" [class.has-error]="definition.showErrors">
              <label *ngIf="definition.label" [id]="'lbl_'+elementId" class="" [for]="elementId" [innerHTML]="definition.label"></label>
              <span [id]="'tTip_'+elementId" class="pfText" [innerHTML]="definition.waterMark" *ngIf="definition.waterMark"></span>
              <ng-content></ng-content>
              <div [id]="'errors-container_'+elementId" [attr.role]="definition.isStatus ? 'status' : null" [attr.aria-live]="definition.isStatus ? 'polite' : null">
                <div [id]="'errors_'+elementId" *ngIf="errorMessage && !definition.alwaysShowErrors" class="text-negative ant-float-left ant-full-width error-msgs clearfix">
                  <span [id]="elementId+'Err'" class="ant-form-item-error ant-float-left" [innerHTML]="errorMessage"></span>
                </div>
                <div class="clearfix" [id]="'errors_'+elementId" *ngIf="definition.alwaysShowErrors && definition.showErrors">
                  <ng-container *ngFor="let errDef of (definition.errorDefs | objKeys); let i = index;">
                    <span [id]="'err_'+elementId+i" class="ant-float-left ant-full-width" [class.ant-form-item-error]="definition.inputErrors && definition.inputErrors[errDef]" [class.ant-form-item-valid]="!definition.inputErrors || !definition.inputErrors[errDef]"
                    [innerHTML]="definition.errorDefs[errDef]"></span>
                  </ng-container>
                </div>
              </div>
             </div>`
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { definition: [{
                type: Input
            }], inputElement: [{
                type: ContentChild,
                args: ["input", { read: ElementRef, static: false }]
            }] } });
class ObjectKeysPipe {
    transform(value) {
        return value ? Object.keys(value) : [];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ObjectKeysPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ObjectKeysPipe, name: "objKeys" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ObjectKeysPipe, decorators: [{
            type: Pipe,
            args: [{ name: "objKeys" }]
        }] });

class FormGroupModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FormGroupModule, declarations: [FormItemComponent, FieldSetWrapperComponent, ObjectKeysPipe], imports: [CommonModule], exports: [FormItemComponent, FieldSetWrapperComponent, ObjectKeysPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormGroupModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [FormItemComponent, FieldSetWrapperComponent, ObjectKeysPipe],
                    exports: [FormItemComponent, FieldSetWrapperComponent, ObjectKeysPipe]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FieldSetWrapperComponent, FormGroupModule, FormItemComponent, ObjectKeysPipe };
